<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{data.nzTitle}}</p>
	</div>
</div>

<div class="mx-4">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else {
		<div class="mt-4">
			<form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
				<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">

					<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
						<nz-form-label nzRequired>
							Motivo de la pausa
						</nz-form-label>
						<nz-form-control nzErrorTip="Indique el motivo de la pausa">
							<nz-select nzShowSearch nzPlaceHolder="Indique el motivo de la pausa" formControlName="selectedReason">
								@for (pauseReason of pauseReasons; track pauseReason) {
								<nz-option [nzValue]="pauseReason.id" [nzLabel]="pauseReason.name">
								</nz-option>
								}
							</nz-select>
						</nz-form-control>
					</nz-form-item>

					<nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
						<nz-form-label>
							Observaciones
						</nz-form-label>
						<nz-form-control nzErrorTip="Indique información acerca de la pausa">
							<textarea formControlName="observations" nz-input rows="4"
								placeholder="Indique información acerca de la pausa"></textarea>
						</nz-form-control>
					</nz-form-item>

				</div>
			</form>
		</div>
	}
</div>
<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button mr-2">
			Cancelar
		</button>

		<button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
			Aceptar
		</button>
	</div>
</div>
